module.exports = {
	"linkAccess": "Staff Access",
	"linkLogo": "Logo & seller image",
	"linkProfile": "Seller profile",
	"profile": {
		"header": "Organization profile settings"
	},
	"menu": {
		"backToMain": "Back to main site",
		"backToDashboard": "Back to dashboard"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/oa-settings.json5
// module id = 1946
// module chunks = 6